module.exports = __webpack_public_path__ + "img/target.e4292e7e.svg";